import { USER_SERVICE } from "@/services/consts";

export const ROLE_API = `${USER_SERVICE}roles`;
